import { t } from "@travily/i18n";
import communityIllustration from "@ui/assets/illustrations/community-animated.webp";
import { Wizard } from "@ui/components/Wizard";
import { WizardTextArea } from "@ui/components/WizardTextArea";
import type { ReactNode } from "react";

const COLOR = "yellow" as const;

export interface FoundingMemberCommunityConnectStepViewProps {
  /** 1-indexed current stage, drives the progress bar. */
  currentStage: number;
  /** Total number of stages in the wizard. */
  totalStages: number;
  /** Back handler; omit to hide the back affordance (first stage). */
  onBack?: () => void;
  /** Pre-built top-bar tertiary actions (Questions / Save and finish later). */
  topBarActions: ReactNode;
  /** Advances the wizard to the next stage. */
  onPrimary: () => void;
  /** Whether the primary action is in a pending/submitting state. */
  primaryPending: boolean;
  /** Current value of the socials textarea. */
  socials: string;
  /** Field-level validation error for the socials input. */
  error?: string;
  /** Fired on every keystroke with the new textarea value. */
  onSocialsChange: (value: string) => void;
}

export function FoundingMemberCommunityConnectStepView({
  currentStage,
  totalStages,
  onBack,
  topBarActions,
  onPrimary,
  primaryPending,
  socials,
  error,
  onSocialsChange,
}: FoundingMemberCommunityConnectStepViewProps) {
  return (
    <Wizard color={COLOR} currentStage={currentStage} totalStages={totalStages} onBack={onBack}>
      {topBarActions}
      <Wizard.PrimaryButton onPress={onPrimary} isPending={primaryPending}>
        {t("common.actions.continue")}
      </Wizard.PrimaryButton>
      <Wizard.Stage
        illustration={<img alt="" aria-hidden="true" src={communityIllustration} />}
        heading={t("web.founding_members.creator.steps.community.connect.show.title")}
      >
        <div className="w-full max-w-[600px]">
          <WizardTextArea
            color={COLOR}
            errorMessage={error}
            isInvalid={Boolean(error)}
            isLabelHidden
            label={t("web.founding_members.creator.steps.community.connect.show.label")}
            onChange={onSocialsChange}
            placeholder={t("web.founding_members.creator.steps.community.connect.show.placeholder")}
            rows={4}
            value={socials}
          />
        </div>
      </Wizard.Stage>
    </Wizard>
  );
}
